import React, { useState, useEffect } from 'react';
import assetsCompareServices from './assetsCompareServices';
import Pagination from '../../Header/Pagination';
import { Filter } from '../../../filter';
import PeriodSelectionForm from '../../PeriodSelection/periodSelectionForm';
import { format } from 'date-fns';
import directoryServices from '../../directories/directoryServices';
import cachingMechanisum from '../../Common/cachingMechanisum';

export default function SQLTrend() {

    let [showSEK, setshowSEK] = useState(false);
    let [searchFor, setsearchFor] = useState("");
    let [reportingTo, setreportingTo] = useState("");
    let [BuildStatus, setBuildStatus] = useState(false);
    let [reportingFrom, setreportingFrom] = useState("");
    let [AssetType, setAssetType] = useState("Contracts");
    let [TrendsTotalRow, SetTrendsTotalRow] = useState<any>([]);
    let [TrendsAnalysis, SetTrendsAnalysis] = useState<any>([]);
    let [periodSelection, setperiodSelection] = useState(false);

    var payload = { WchOne: 9, PerFrom: reportingFrom, PerTo: reportingTo, PageNumber: 1, PageSize: 10, searchFor: searchFor }
    let [periodSelected, SetperiodSelected] = useState<any>([]);

    useEffect(() => {

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        console.log(periodListCache)
        for (var i = 0; i < periodListCache.length; i++) {
            if (periodListCache[i].periodCurrent === 1) {
                periodSelected = periodListCache[i]
                SetperiodSelected(periodSelected)
            }
        }
        if (window.location.href.indexOf('bellgroup') > 0) {
            setshowSEK(true)
        } else {
            setshowSEK(false)
        }

        reportingFrom = String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom));
        reportingTo = String(Filter.DateTimeFormatNumber(periodSelected?.periodTo));

        setreportingFrom(String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom)));
        setreportingTo(String(Filter.DateTimeFormatNumber(periodSelected?.periodTo)));

        console.log(typeof (reportingFrom) )
        console.log(reportingTo)


        if (reportingFrom === "[object Object]") {
            reportingFrom = "20200131"
            setreportingFrom(reportingFrom)
        }

        if (reportingTo === "[object Object]") {
            reportingTo = "20290131"
            setreportingTo(reportingTo)
        }
        console.log(reportingFrom)
        console.log(reportingTo)

    }, []);

    const searchSummary = (searchText: any) => {
        apiSearch();
    }

    const paginationHandler = (n: any) => {
        console.log(n);
        payload.PageNumber = n.pageNumber;
        payload.PageSize = n.pageSize;
        apiSearch();
    }

    //Contract List     9
    //Assets List       7
    //Assets Build      6
    //contract Build    8

    const apiSearch = () => {

        if (AssetType === "Contracts") { payload.WchOne = 9 }
        if (AssetType === "Assets") { payload.WchOne = 7 }
        assetsCompareServices.trendsAnalysis(payload).then((vaules: any) => {
            SetTrendsTotalRow(vaules && vaules[0] && vaules[0].totalRows ? vaules[0].totalRows : 0);
            SetTrendsAnalysis(vaules);

            if (payload.WchOne === 8 && vaules) {
                BuildStatus = true;
                setBuildStatus(BuildStatus);
            }
        })

        setTimeout(function () {
            setBuildStatus(false);
        }, 3000);
    }

    const onChangePeriod = (period: any) => {

        if (period.periodFrom) {
            payload.PerFrom = period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd');
            reportingFrom = period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd');
            setreportingFrom(period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd'));
        }

        if (period.periodTo) {
            payload.PerTo = period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd');
            reportingTo = period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd');
            setreportingTo(period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd'));
        }

        if (period && period.action && period.action === 2) {

            apiSearch();
        }
    }

    const closePeriod = (e: any) => {
        console.log(e)
        periodSelection = false;
        setperiodSelection(false)
    }

    const buildTrendTable = () => {

        if (AssetType === "Contracts") { payload.WchOne = 8 }
        if (AssetType === "Assets") { payload.WchOne = 6 }

        apiSearch();
    }

    const ExportBuild = () => {

        if (AssetType === "Contracts") { payload.WchOne = 9 }
        if (AssetType === "Assets") { payload.WchOne = 7 }

        payload.PageSize = 5000000;
        var fpayload = { Type: "TrendTableSQL", exportType: "TrendTableSQL", ...payload }
        directoryServices.excelGenericExport(fpayload)
    }

    return (<>
        <div className="landing ws-12">

            <div className='ws-12 pLarge'>

                <div className="ws-12 ptxl mtl">
                    <span className="ws-12 text-bold text-xl">{AssetType} Trend</span>
                    <span className="ws-12 ptl text-bold text-m turquoise">Trend Listing</span>
                </div>

                <div className='ws-12'>
                    <ul className="nav nav-tabs p0 m0 pull-right">
                        <li className={AssetType === "Contracts" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { AssetType = 'Contracts'; setAssetType(AssetType); apiSearch() }}>Contract</li>
                        <li className={AssetType === "Assets" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { AssetType = 'Assets'; setAssetType(AssetType); apiSearch() }}>Assets</li>
                    </ul>
                </div>

                <div className="ws-12 ptxl">

                    <div className="ws-8 mbl">
                        <button className="btn white pLarge bg-level14 m0 ws-2" onClick={() => searchSummary(searchFor)}> Search</button>
                        <input type="text" value={searchFor} onChange={(e) => setsearchFor(e.target.value)} className="pLarge ws-10 m0 heightReset" placeholder="Type to search" />
                    </div>

                    <div className='pull-right'>
                        <button className="btn-queue pull-left pm" onClick={buildTrendTable}>Build Table </button>

                        <button className="icon-btn edit pull-left pm" onClick={ExportBuild}>Export </button>

                        <div className="pull-left">
                            <div className="ws-12">
                                <div className="centerWindow ws-12">
                                    <a className="icon-btn edit pm ws-12" onClick={() => setperiodSelection(true)}>
                                        <i className="icon-angle-right text-m pull-right mll"></i>
                                        <span className="pull-right success"> {Filter.NumToDate(reportingTo)}</span>
                                        <i className="icon-vertical-line ml pull-right mr text-sl success"></i>
                                        <span className="pull-right success">{Filter.NumToDate(reportingFrom)}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {BuildStatus && <div className="pm ws-12 "> <div className="alert pm" >Data table Build</div> </div>}
                </div>

                <div className="ws-12 bgWhite mbl">
                    {(TrendsTotalRow > 0) && <div className="ws-12 box">

                        <div className="ws-12 pm ptl pt pb">
                            <span className="text-bold text-m">Showing <span className="info">{TrendsTotalRow}</span> results</span>
                        </div>

                        <div className='ws-12 mtl pLarge tableVertical'>
                            <table className={'bgWhite table tablePresentation'}>
                                <thead>
                                    <tr>
                                        <th className="text-center">Account</th>
                                        <th className="text-center">DSP</th>
                                        <th className="text-center">Period</th>
                                        {AssetType === 'Contracts' && <th className="text-center">Contract</th>}
                                        <th className="text-center">Asset Code</th>
                                        <th className="text-center">Asset Title</th>
                                        <th className="text-center">Asset Artist</th>
                                        <th className="text-center">Quantity</th>
                                        <th className="text-center">Value</th>
                                        {showSEK && <th className="text-center">Value(SEK)</th>}
                                        <th className="text-center">Territory</th>
                                        <th className="text-center">Format</th>
                                        <th className="text-center">CustomID</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {TrendsAnalysis?.map((list: any, index: any) => {
                                        return (<>
                                            <tr>
                                                <td >{list?.account}</td>
                                                <td >{list?.dsp}</td>
                                                <td >{list?.period}</td>
                                                {AssetType === 'Contracts' && <td >{list?.contract}</td>}
                                                <td >{list?.code}</td>
                                                <td >{list?.title}</td>
                                                <td >{list?.artist}</td>
                                                <td >{list?.quantity}</td>
                                                <td >{list?.value}</td>
                                                {showSEK && <td >{list?.value2}</td>}
                                                <td >{list?.territory}</td>
                                                <td >{list?.format}</td>
                                                <td >{list?.customID}</td>
                                            </tr>
                                        </>)
                                    })}
                                </tbody>
                            </table>

                            <div className="clearfix ws-12 pm">
                                {(() => {
                                    if (TrendsTotalRow > 10) {
                                        return  <Pagination onPageChange={paginationHandler} totalRow={TrendsTotalRow} />
                                    }
                                })()}
                            </div>
                        </div>
                    </div>}

                </div>

                {(() => {
                    if (periodSelection === true) {
                        return <PeriodSelectionForm open={periodSelection} closePeriod={closePeriod} onChange={onChangePeriod} periodFrom={Filter.convertToDateString(reportingFrom)} periodTo={Filter.convertToDateString(reportingTo)} />;
                    }

                })()}

            </div>
        </div>
    </>)

}